export class RequestSptPostModel {
  public RequestId?: number;
  public Spt?: number;
  public IsExcluded?: boolean;
  public Remarks?: string;
}

export class RequestSptPutModel {
  public id?: number;
  public RequestId?: number;
  public Spt?: number;
  public Remarks?: string;
  public IsExcluded?: boolean;
  public updatedBy?: string;
  public updatedDate?: Date;
}
